document.addEventListener('click', (event) => {
  const $target = event.target.closest('.user-area__icon-button--close');
  if ($target) {
    const $targetPanel = $target.closest('.user-area__panel');
    $targetPanel.hidden = true;
  }
});
